const // host="http://iraq-gis.com:3001/"
  // host = "https://www.iraq-gis.com/ticket_v2/";
  host = "https://ticket.is.iq/ticket/";//new ticket host, google
  // host = "http://34.72.109.192:3001/";//new ticket host, google
// host = "http://10.15.61.104:3001/";
// host="http://192.168.15.184:3001/";
// host="http://localhost:3001/";
// host="http://10.15.61.104:3001/";
// host="http://192.168.137.16:3001/"; //Saif Esmail laptop
// host="http://192.168.42.61:3001/";
//  host="http://192.168.80.4:3001/"
//  host="http://192.168.80.150:3001/"
// host="http://www.iraq-gis.com:3001/ "

export default host;
